import { createQueryKeys } from '@lukemorales/query-key-factory';

import type { SearchPreordersParams } from './useSearchPreorders';

/**
 * Query keys for preorders API calls
 *
 * Structure:
 * - list (Algolia-based search)
 * - stats (aggregate data)
 */
export const preorders = createQueryKeys('preorders', {
	list: (servicesProviderId: string, params?: SearchPreordersParams) => ({
		queryKey: [servicesProviderId, params],
	}),

	stats: (servicesProviderId: string) => ({
		queryKey: [servicesProviderId],
	}),

	detail: (servicesProviderId: string, preorderId: string) => ({
		queryKey: [servicesProviderId, preorderId],
	}),
});
